// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-wrapper{display:flex;flex-direction:column}.text-block{overflow-y:hidden;padding-bottom:32px}.btn-toggle{width:80px;border-radius:8px;margin-left:auto;margin-right:auto;line-height:32px;cursor:pointer;margin-bottom:8px}.btn-toggle img{width:15px;height:15px}.btn-toggle:hover{background-color:rgba(0,0,0,.1);border-color:1px solid #ccc}.text-wrapper p{margin:0}", ""]);
// Exports
module.exports = exports;
